import api from './api';

const manualBudgetService = {
  createBudget: async (budgetData) => {
    const response = await api.post('/manual-budgets', budgetData);
    return response.data;
  },

  listBudgets: async (params = {}) => {
    const response = await api.get('/manual-budgets', { params });
    return response.data;
  },

  getBudget: async (id) => {
    const response = await api.get(`/manual-budgets/${id}`);
    return response.data;
  },

  updateBudget: async (id, budgetData) => {
    const response = await api.put(`/manual-budgets/${id}`, budgetData);
    return response.data;
  },

  deleteBudget: async (id) => {
    const response = await api.delete(`/manual-budgets/${id}`);
    return response.data;
  },

  addItem: async (budgetId, itemData) => {
    const response = await api.post(`/manual-budgets/${budgetId}/items`, itemData);
    return response.data;
  },

  updateItem: async (budgetId, itemId, itemData) => {
    const response = await api.put(`/manual-budgets/${budgetId}/items/${itemId}`, itemData);
    return response.data;
  },

  deleteItem: async (budgetId, itemId) => {
    const response = await api.delete(`/manual-budgets/${budgetId}/items/${itemId}`);
    return response.data;
  },

  generatePDF: async (budgetId) => {
    const response = await api.post(`/manual-budgets/${budgetId}/generate-pdf`);
    return response.data;
  },

  downloadPDF: async (budgetId, fileName) => {
    const response = await api.get(`/manual-budgets/${budgetId}/pdf?file=${fileName}`, {
      responseType: 'blob'
    });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/manual-budgets/stats');
    return response.data;
  },

  formatCurrency: (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  },

  formatDate: (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  },

  calculateItemTotal: (quantity, unitPrice) => {
    return (quantity || 1) * (unitPrice || 0);
  },

  calculateSubtotal: (items) => {
    if (!items || items.length === 0) return 0;
    return items.reduce((sum, item) => sum + manualBudgetService.calculateItemTotal(item.quantity, item.unitPrice), 0);
  },

  calculateTotalWithDiscount: (subtotal, discount) => {
    if (!discount || discount.type === 'NONE') return subtotal;
    if (discount.type === 'PERCENT') {
      return subtotal * (1 - (discount.value || 0) / 100);
    }
    if (discount.type === 'FIXED') {
      return Math.max(0, subtotal - (discount.value || 0));
    }
    return subtotal;
  },

  calculatePaymentCondition: (totalAmount, condition) => {
    if (!condition) return totalAmount;

    if (condition.type === 'VISTA') {
      return totalAmount;
    }

    const installments = condition.installments || 1;
    const baseAmount = totalAmount / installments;

    if (condition.interestRate && condition.interestRate > 0) {
      return baseAmount * (1 + condition.interestRate / 100) * installments;
    }

    return totalAmount;
  }
};

export default manualBudgetService;